export default class Caja {
    constructor(gestion = '', cod_interno = '', cant_carpetas = '', reg_inicial = '', reg_final = '', observaciones = '', agencia_id = null) {
        this.gestion = gestion;
        this.cod_interno = cod_interno;
        this.cant_carpetas = cant_carpetas;
        this.reg_inicial = reg_inicial;
        this.reg_final = reg_final;
        this.observaciones = observaciones;
        this.agencia_id = agencia_id;
    }
}